<template>
  <div class="bg-player-secret">
    <div class="container header-page">
      <!-- <div class="poster-offline">
        <img src="../../src/assets/img/FinalPoster/channeloffline640x480.png" class="img-live" />
      </div> -->
      <mdb-row class="area-player-secretbod">
        <div class="area-player-vod">
        <div class="player">
            <div class="player-site" id="player-site">
              <!-- <div class="overlay-live" id="overlay">
                <img src="../assets/img/live.png" class="icon-live-player" />
                <p class="view-live"><i class="fa fa-eye"></i> {{views}}</p>
              </div> -->
              <div class="btn-close" id="close-video" @click="closeSticky()">
                <i class="fa fa-times close-video" aria-hidden="true"></i>
              </div>
              <!-- <div class="overlay">
              <input type="password" />
              </div>-->
              <div class="overlay-education" id="overlay-education">
                <p style="margin-bottom: 0;">กรุณาคลิกเลือกวีดีโอก่อน</p>
                <p style="margin-top: 0; margin-left: 0; margin-right: 0;">แล้วกรอกรหัสผ่าน</p>
                <input
                  style="text-align: center;"
                  id="input_education"
                  :class="{miss:css}"
                  @input="handleInput($event.target.value)"
                  @
                  maxlength="4"
                  type="password"
                />
              </div>
              <video
                id="player-live"
                class="video-js vjs-default-skin vjs-16-9 full"
                ref="videoPlayer"
                height="360"
                controls
              ></video>
            </div>
          </div>
      </div>

      <div class="area-playlist-vod">
            <div class="playlist">
              <mdb-card class="playlist-card">
                  <!-- <span class="text-header-playlist">Special Video</span> -->
                <mdb-card-body class="card-playlist-video" id="ScrollBar-playlist">

                  <slick ref="slick" class="area-slick-vod" :options="slickOptions" v-if="specialVod.length">
                    <div class="slick-vod" v-for="item in specialVod" @click="playVideo(item.id)">
                      <div class="mb-2">
                        <figure class="sixteen-nine-img">
                          <img :src="item.thumb" />
                          <!-- <div class="btn-overlay-slick-vod">
                            <fa icon="play" class="icon-play-category"/>
                          </div> -->
                        </figure>
                      </div>
                      <div class="detail-playlist-video">
                        <h4 class="title-playlist-video">{{item.name}}</h4>
                        <p class="card-date-secret">รับชมทั้งหมด {{Number(item.views).toLocaleString()}} ครั้ง</p>
                        <p class="card-desc-secret">{{item.desc}}</p>
                        <!-- <star-rating :star-size="12" :rating="item.avgrate" class="star-rating-playlist-mobile" :read-only="true" :round-start-rating="false"></star-rating> -->
                      </div>
                    </div>
                  </slick>


                  <div class="playlist-related">
                    <div class="box-playlist-video" v-for="item in specialVod" @click="playVideo(item.id)">
                      <div class="video-playlist-video">
                        <figure class="sixteen-nine-img float-left thumb-playlist-video">
                          <img :src="item.thumb" >
                          <!-- <div class="btn-overlay-playlist">
                            <fa icon="play" class="icon-play"/>
                          </div> -->
                        </figure>
                      </div>
                      <div class="detail-playlist-video">
                        <p class="title-playlist-video">{{item.name}}</p>
                        <p class="card-date-secret">รับชมทั้งหมด {{Number(item.views).toLocaleString()}} ครั้ง</p>
                        <p class="card-desc-secret">{{item.desc}}</p>
                      </div>
                        <!-- <star-rating :star-size="12" :rating="item.avgrate" class="star-rating-playlist" :read-only="true" :round-start-rating="false"></star-rating> -->
                    </div>
                  </div>

                </mdb-card-body>
              </mdb-card>
            </div>
          </div>
      </mdb-row>
      
          

      <div class="area-desc-secret">
        <div class="title-video  mt-4">
          <div class="function-livepage">
            <a @click.prevent="downloadItem(download)" download>
            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
              <div class="tooltip">
                ดาวน์โหลด
              </div>
              <btn slot="reference" class="btn-download" type="submit" name="button" v-show="checkDownload == 'true'">
                <fa icon="download" class="icon-download" />
              </btn>
            </mdb-tooltip>
            </a>
            <!--btn class="btn-fav" type="submit" name="button">
            <fa icon="heart" class="icon-fav" />
          </btn>
          <btn class="btn-history" type="submit" name="button">
            <fa icon="history" class="icon-history" />
            </btn-->
            <tooltip trigger="hover" :options="{placement: 'top'}">
              <div class="tooltip">แชร์</div>
              <btn
                slot="reference"
                class="btn-share"
                type="submit"
                name="button"
                @click.native="modalShare = true"
                @click="ShareLink()"
              >
                <fa icon="share" class="icon-share" />
              </btn>
            </tooltip>
          </div>
          <h4 class="ml-2 header-vod-secret">{{Title}}</h4>
          <p class="ml-2 text-count-vod-secret">รับชมทั้งหมด {{Number(views).toLocaleString()}} ครั้ง</p>
        </div>

        <div class="detail-video">
          <div class="box-user">
            <img src="../../src/assets/img/FinalPoster/avatar45x45.png" class="avatar-channal" />
            <div class="user-detail">
              <p class="nameChannal-vod-secret" v-if="!Publisher">ROYAL THAI AIR FORCE</p>
              <p class="nameChannal-vod-secret" v-if="Publisher">{{Publisher}}</p>
            </div>
            <div class="description">
              <read-more
                class="text-desc-secret"
                more-str="แสดงรายละเอียด"
                :text="Desc"
                less-str="ย่อรายละเอียด"
                :max-chars="200"
              ></read-more>
            </div>
          </div>
        </div>
      </div>

      <div class="area-comment mt-4">
        <div class="header-comment-vod-secret" >
               <h5>ความคิดเห็น</h5>
              </div>
                <div class="comment-area" >
                  <div class="">
                    <div class="detail-video-desc" v-for="comment in comments" :key="comment.id" >
                      <div class="box-user">
                        <img :src="comment.thumb" class="avatar-channal">
                        <div class="user-detail">
                          <p class="nameUser" >{{comment.name}}</p>
                          <p class="nameUser2">{{comment.updatedAt | formatDate}}</p>
                        </div>
                        <div>
                          <p class="text-comment" >{{comment.message}}</p>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="mt-5">
                      <jw-pagination :items="comments" :pageSize="10" @changePage="onChangePage"></jw-pagination>
                    </div> -->
                    
                  </div>
                </div>
                <div class="mt-5">
                  <div class="insert-comment" >
                    <!-- <h5 class="mb-3 mt-2">Comment</h5> -->
                    <div class="form-group">
                      <label class="desc-text" for="example2">แสดงความคิดเห็น</label>
                      <textarea id="example2" rows="4" v-model="inputcomment" v-validate="'required'" v-on:keyup.enter="addComment()" class="form-control form-control-md" :class="{ 'is-invalid': errors.has('comment') }">
                      </textarea>
                    </div>
                    
                    <!-- <span class="help is-danger">{{ errors.first('comment') }}</span> -->
                    <div class="">
                      <mdb-btn size="md" color="primary" :disabled="errors.any() || inputcomment == '' " @click="addComment()">ส่งความคิดเห็น</mdb-btn>
                    </div>
                  </div>
                  <!-- <div class="insert-account mt-5" v-show="!auth">
                    {{ $t('commentdesc') }}
                    <modal ref="modal"></modal>
                    <mdb-btn class="" @click="openModal()" color="primary" >{{ $t('login') }}</mdb-btn>
                  </div> -->
                </div>
              </div>

              

      <!-- Modal share -->
      <modal centered v-if="modalShare" @close="modalShare = false">
        <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
        <modal-header>
          <modal-title>Share</modal-title>
        </modal-header>
        <modal-body class="body-share">
          <div class="padding-share">
            <!--div class="text-center input-share">
        <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
            </div-->
            <div class="input-link input-share">
              <input
                type="text"
                v-model="Link"
                id="linkURL"
                class="form-control shareLink"
                readonly="readonly"
              />
              <btn color="primary" class="btn-chat" @click="CopyLink()">
                <span>คัดลอก</span>
              </btn>
            </div>
            <!--div class="">
        <btn class="btn-email" color="white"><fa icon="envelope" class="icon-link" /> อีเมล</btn>
      </div>
      <div class="">
        <btn class="btn-facebook" color="primary"><fa icon="facebook" class="icon-social" /> facebook</btn>
      </div>
      <div class="">
        <btn class="btn-line" color=" green accent-4"><fa icon="line" class="icon-social" />Line</btn>
            </div-->
          </div>
        </modal-body>
      </modal>
      <!-- /Modal share -->
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
// const videojs = require("video.js");
import videojs from 'video.js';
require("videojs-contrib-hls");
//require('videojs-contrib-quality-levels');
//require('videojs-hls-quality-selector');
import {
  mdbIcon,
  mdbInput,
  mdbBtn,
  mdbRow,
  mdbCol,
  Btn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Tooltip,
  mdbTooltip
} from "mdbvue";
import config from "../config";
import axios from "axios";
import "vue-pay-password/dist/vue-pay-password.css";
const Host = config.app.Host;
export default {
  name: "PlayerVodSecretPage",
  components: {
    mdbIcon,
    mdbRow,
    mdbBtn,
    mdbCol,
    mdbInput,
    Btn,
    mdbCard,
    mdbCardBody,
    Fa,
    mdbCardHeader,
    videojs,
    Slick,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Tooltip,
    mdbTooltip
  },
  data() {
    return {
      css: false,
      checkDownload: '',
      type: "",
      comments: [],
      pageOfItems: [],
      specialVod: [],
      video: true,
      Publisher: null,
      status: "",
      offline: false,
      idlive: "",
      views: "0",
      Link: null,
      inputcomment: "",
      modalShare: false,
      active: 0,
      elHeight: 0,
      MessageDetail: "",
      Title: "",
      Desc: "",
      message: null,
      stream_url: "",
      player: null,
      msg:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      Related: [],
      slickOptions: {
        infinite: false,
        prevArrow: "<a class='btn-floating-vod slick-left-vod'><i class='fa fa-chevron-left'></i></a>",
        nextArrow: "<a class='btn-floating-vod slick-right-vod'><i class='fa fa-chevron-right'></i></a>",
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 430,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            autoplay: false
          }
        }]
        // Any other options that can be got from plugin documentation
      },
      playerOptions: {
        height: 500,
        hls: true,
        autoplay: true,
        language: "en",
        sources: [
          {
            type: "application/x-mpegURL",
            src: ""
          }
        ],
        flash: {
          hls: { withCredentials: false }
        },
        html5: {
          hls: { withCredentials: false }
        },
        poster: ""
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  updated() {
    this.$nextTick(function () {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions);
      }
    });
  },
  mounted() {
    this.DetailLiveFirst();
    this.ToggleLogin();
    localStorage.pincode = "";
    this.Session();
    this.feedComment();
  },
  methods: {
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    closeSticky() {
      document.getElementById("player-site").classList.remove("player-sticky");
      this.video = false;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      try {
        if (this.window.width <= "414") {
          window.onscroll = () => {
            if (
              window.pageYOffset >= "40" &&
              this.window.width <= "414" &&
              this.video == true
            ) {
              document
                .getElementById("player-site")
                .classList.add("player-sticky");
              document
                .getElementById("close-video")
                .classList.add("display-in");
              document.getElementById("overlay").classList.add("display-none");
            } else {
              document
                .getElementById("player-site")
                .classList.remove("player-sticky");
              document
                .getElementById("close-video")
                .classList.remove("display-in");
              document
                .getElementById("overlay")
                .classList.remove("display-none");
            }
          };
        } else {
          document
            .getElementById("player-site")
            .classList.remove("player-sticky");
        }
      } catch (e) {
        console.log("");
      }
    },
    Session() {
      let APIgetSession = Host + "/api/v1/member/session";
      axios
        .post(APIgetSession, {
          token: localStorage.token
        })
        .then(response => {
          if (response.data.code !== "200") {
            localStorage.emailfront = "";
            localStorage.token = "";
            localStorage.auth = "false";
          }
        });
    },
    ToggleLogin() {
      if (localStorage.auth == "false" || !localStorage.auth) {
        this.$router.push("/");
      }
      this.modalLogin = true;
    },
    ShareLinkRelated(data) {
      this.Link = data.share;
    },
    handleInput(value) {
      // console.log(value);
      if (value.length === 4) {
        let liveid = this.$route.params.data;
        let APICheckSecret = Host + "/api/v1/video/secret/check";
        axios
          .post(APICheckSecret, {
            id: liveid,
            pincode: value
          })
          .then(res => {
            if (res.data.status === "success") {
              document
                .getElementById("overlay-education")
                .classList.add("display-none");
              this.playSecret();
            } else {
              document
                .getElementById("input_education")
                .classList.add("input-wrong");
              this.css = true;
              var self = this;
              setTimeout(function() {
                document
                  .getElementById("input_education")
                  .classList.remove("input-wrong");
                self.alert = "";
                self.css = false;
              }, 2000);
            }
          });
      }

      // this.inputData = value;
    },
    addComment() {
      let liveid = this.$route.params.data;
      let APIAddComment = Host + "/api/v1/video/comment/add";
      axios
        .post(APIAddComment , {
          id: liveid,
          message: this.inputcomment,
          email: localStorage.emailfront
        }).then(res => {
          this.inputcomment = '';
          this.$nextTick(() => {
            this.$validator.reset();
          });
          this.feedComment();
        });
    },
    feedComment() {
      let liveid = this.$route.params.data;
      
      let APIGetComment = Host + "/api/v1/video/comment";
      axios
        .post(APIGetComment, {
          id: liveid
        }).then(res => {
          this.comments = res.data.result;
        });
    },
    playVideo(data) {
      window.location.href = '/#/specialVOD/' + data;
      location.reload();
      this.DetailLiveFirst();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    playSecret() {
      let liveid = this.$route.params.data;
      let APIGetDetailLive = Host + "/api/v1/video/play";
      axios
        .post(APIGetDetailLive, {
          id: liveid,
          email: localStorage.emailfront
        })
        .then(response => {
          // console.log(response);
          this.checkDownload = response.data.download;
          this.download = response.data.download_url;
          this.views = response.data.views;
          this.Link = response.data.share;
          this.Title = response.data.name;
          this.Desc = response.data.desc;
          this.stream_url = response.data.stream_url;
          // this.playerOptions.sources[0].src = response.data.stream_url;
          this.playerInitialize();
          this.playerSetupEvents();
        })
        .catch(error => {
          console.log(error);
        });
    },
    DetailLiveFirst() {
      let secretVideo = this.$route.params.data;
      let APIPlayVideoSecret = Host + "/api/v1/video/play";
      axios
        .post(APIPlayVideoSecret, {
          email: localStorage.emailfront,
          id: secretVideo
        })
        .then(res => {
          this.secretVideoRelated();
          document.getElementById("overlay-education").classList.remove("d-none");
          // this.checkDownload = res.data.download;
          // this.download = res.data.download_url;
          this.views = res.data.views;
          this.Link = res.data.share;
          this.Title = res.data.name;
          this.Desc = res.data.desc;
        });
    },
    secretVideoRelated() {
      let secretVideo = this.$route.params.data;
      let APIPlayVideoSecret = Host + "/api/v1/video/secret";
      axios
        .post(APIPlayVideoSecret , {
          email: localStorage.emailfront,
          id: secretVideo,
          type: 'secret'
        }).then(res => {
          this.specialVod = res.data.result;
        });
    },
    playerDispose() {
      this.player.dispose();
    },
    playerInitialize() {
      this.playerOptions.sources[0].src = this.stream_url;
      this.player = videojs("player-live", this.playerOptions);
      this.player.hlsQualitySelector();
    },
    playerSetupEvents() {
      this.player.on("error", function() {
        window.playerEvents.playerEventError();
      });
    },
    // scrollToEnd() {
    //   var container = this.$el.querySelector(".body-chat");
    //   container.scrollTop = container.scrollHeight;
    // },
    downloadItem (url) {
      window.open(url, '_blank');
      // console.log(url);
      // axios.get(url, { responseType: 'blob' })
      //   .then(({ data }) => {
      //     let blob = new Blob([data], { type: 'video/mp4' });
      //     let link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(blob);
      //     link.download = '';
      //     link.click();
      //   });
    },
    Download() {
      axios({
        url: 'http://covteam.u.qiniudn.com/oceans.mp4',
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download' , 'file');
        document.body.appendChild(link);
        link.click();
      });
      // window.location.href = this.download;
    },
    ShareLink() {
      let lastupdateid = this.$route.params.data;
      let APIgetShareLink = Host + "/api/v1/video/play";
      axios
        .post(APIgetShareLink, {
          email: localStorage.emailfront,
          id: lastupdateid
        })
        .then(response => {
          this.Link = response.data.share;
        });
    },
    CopyLink() {
      let coding = document.querySelector("#linkURL");
      coding.setAttribute("type", "text");
      coding.select();

      try {
        var successful = document.execCommand("copy");
        if (successful == true) {
          this.success();
        }
      } catch (err) {
        console.log("error, please copy by Ctrl+C.");
      }
    },
    success() {
      this.$alert.success({
        message: "คัดลอกลิ้งค์แล้ว",
        position: "bottom left",
        timeOut: 3000
      });
    },
    beforeEnter(el) {
      el.style.height = 0;
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave(el) {
      el.style.height = 0;
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
    // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    beforeUpdate() {
      if (this.$refs.slick) {
        this.$refs.slick.destroy();
      }
    },
    // listen event
    onPlayerPlay(player) {
      console.log("player play!", player);
    },
    onPlayerPause(player) {
      console.log("player pause!", player);
    },
    onPlayerEnded(player) {
      console.log("player ended!", player);
    },
    onPlayerLoadeddata(player) {
      console.log("player Loadeddata!", player);
    },
    onPlayerWaiting(player) {
      console.log("player Waiting!", player);
    },
    onPlayerPlaying(player) {
      console.log("player Playing!", player);
    },
    onPlayerTimeupdate(player) {
      console.log("player Timeupdate!", player.currentTime());
    },
    onPlayerCanplay(player) {
      console.log("player Canplay!", player);
    },
    onPlayerCanplaythrough(player) {
      console.log("player Canplaythrough!", player);
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      console.log("player current update state", playerCurrentState);
    },
    // player is ready
    playerReadied(player) {
      // seek to 10s
      console.log("example player 1 readied", player);
      player.currentTime(10);
      // console.log('example 01: the player is readied', player)
    },
    beforeRouteUpdate(to, from, next) {
      this.playerDispose();
      window.scrollTo(0, 0);
    },
    beforeDestroy() {
      this.playerDispose();
    }
  }
};

</script>

<style lang="css">
.area-object {
  position: relative;
  overflow: hidden;
}

.area-player {
  width: 100%;
  height: auto;
}

.area-player img {
  max-width: 100%;
}

.area-chat-left {
  width: 100%;
  height: auto;
}

@media only screen and (min-width: 1080px) {
  /*.area-chat {
    display: none;
  }*/

  .area-player {
    width: 63%;
    float: left;
  }
}

.area-chat-left {
  width: 37%;
  height: auto;
  float: left;
  padding-left: 10px;
}

.chat-lable {
  padding: 12px;
}

.chat-lable h5 {
  margin-bottom: 0;
}

.form-chat {
  position: relative;
  padding-right: 90px;
}

.mesgs {
  padding: 0;
}

.msg_history {
  height: 350px;
  overflow-y: auto;
  background-color: #eeeeee;
  padding: 5px;
}

.incoming_msg_img {
  display: inline-block;
  width: 35px;
  margin-bottom: 15px;
}

.received_msg {
  display: inline-block;
  padding: 0;
  vertical-align: top;
  margin-right: 35px;
  width: 70%;
}

.received_withd_msg p {
  background: transparent none repeat scroll 0 0;
  border-radius: 3px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 0;
  width: 100%;
}

.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}

.img-chat {
  max-width: 30px;
}

.video-js .vjs-menu-button-inline.vjs-slider-active,
.video-js .vjs-menu-button-inline:focus,
.video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 5em !important
}

.video-js .vjs-controls-disabled .vjs-big-play-button {
  display: none !important
}

.video-js .vjs-menu-button-inline:before {
  width: 1.5em !important
}

.vjs-menu-button-inline .vjs-menu {
  left: 3em !important
}

.video-js .vjs-mouse-display:after,
.video-js .vjs-play-progress:after {
  padding: 0 .4em .3em !important
} 

.video-js.vjs-ended .vjs-loading-spinner {
  display: none !important
}

.video-js.vjs-ended .vjs-big-play-button {
  display: block !important
}

.video-js *,
.video-js:after,
.video-js:before {
  box-sizing: inherit !important;
  font-size: inherit !important;
  color: inherit !important;
  line-height: inherit !important
}

.video-js.vjs-fullscreen,
.video-js.vjs-fullscreen .vjs-tech {
  width: 100% !important;
  height: 100% !important
}

.video-js {
  font-size: 14px !important;
  overflow: hidden !important
}

/* .video-js .vjs-control {
  color: inherit !important
} */

.video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 8.35em !important
}

.video-js .vjs-volume-menu-button.vjs-volume-menu-button-horizontal:hover .vjs-menu .vjs-menu-content {
    height: 3em !important;
    width: 6.35em !important
}

.vjs-icon-placeholder{
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

.vjs-icon-placeholder:hover:before {
  text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff !important;
}

/* .video-js .vjs-play-control .vjs-icon-placeholder:hover:before,
.vjs-icon-volume-high:hover:before, .video-js .vjs-mute-control .vjs-icon-placeholder:hover:before {
  text-shadow: 0 0 1em #fff, 0 0 1em #fff, 0 0 1em #fff !important;
} */

/* .video-js .vjs-control:focus:before,
.video-js .vjs-control:hover:before,
.video-js .vjs-control:focus {
  text-shadow: 0em 0em 1em white !important; } */

.video-js .vjs-spacer,
.video-js .vjs-time-control {
  display: -webkit-box !important;
  display: -moz-box !important;
  display: -ms-flexbox !important;
  display: -webkit-flex !important;
  display: flex !important;
  -webkit-box-flex: 1 1 auto !important;
  -moz-box-flex: 1 1 auto !important;
  -webkit-flex: 1 1 auto !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important
}

.video-js .vjs-time-control {
  -webkit-box-flex: 0 1 auto !important;
  -moz-box-flex: 0 1 auto !important;
  -webkit-flex: 0 1 auto !important;
  -ms-flex: 0 1 auto !important;
  flex: 0 1 auto !important;
  width: auto !important;
  padding-left: 0em;
  padding-right: 0em;
  line-height: 36px !important;
}

.video-js .vjs-time-control.vjs-time-divider {
  width: 14px !important
}

.video-js .vjs-time-control.vjs-time-divider div {
  width: 100% !important;
  text-align: center !important
}

.video-js .vjs-time-control.vjs-current-time {
  margin-left: 1em !important
}

.video-js .vjs-time-control .vjs-current-time-display,
.video-js .vjs-time-control .vjs-duration-display {
  font-size: 1.1em !important;
  width: 100% !important
}

.video-js .vjs-time-control .vjs-current-time-display {
  text-align: right !important
}

.video-js .vjs-time-control .vjs-duration-display {
  text-align: left !important
}


.video-js .vjs-remaining-time,
.video-js.vjs-live .vjs-time-control.vjs-current-time,
.video-js.vjs-live .vjs-time-control.vjs-duration,
.video-js.vjs-live .vjs-time-control.vjs-time-divider,
.video-js.vjs-no-flex .vjs-time-control.vjs-remaining-time {
  display: none !important
}

.video-js.vjs-no-flex .vjs-time-control {
  display: table-cell !important;
  width: 4em !important
}

.video-js .vjs-progress-control {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: 10px !important;
  width: 97.4% !important;
  height: .4em !important;
  top: -1.4em !important
}

.vjs-button > .vjs-icon-placeholder:before {
  font-size: 1.8em;
  line-height: 1.67;
}

.video-js .vjs-progress-control .vjs-load-progress,
.video-js .vjs-progress-control .vjs-play-progress,
.video-js .vjs-progress-control .vjs-progress-holder {
  height: 100% !important
}

.video-js .vjs-play-progress:before, .video-js .vjs-volume-level:before {
  display: none;
}

.video-js .vjs-progress-control .vjs-progress-holder {
  margin: 0 !important
}

.video-js .vjs-progress-control:hover {
  height: 0.5em !important;
  top: -1.4em !important
}

.video-js .vjs-seek-to-live-control {
  height: 24px;
}

.vjs-volume-bar.vjs-slider-horizontal {
  height: 0.5em;
}

.vjs-slider-horizontal .vjs-volume-level {
  height: 0.5em;
}

.video-js .vjs-control-bar {
  -webkit-transition: -webkit-transform .1s ease 0s !important;
  -moz-transition: -moz-transform .1s ease 0s !important;
  -ms-transition: -ms-transform .1s ease 0s !important;
  -o-transition: -o-transform .1s ease 0s !important;
  transition: transform .1s ease 0s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active .vjs-control-bar,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar {
  visibility: visible !important;
  opacity: 1 !important;
  -webkit-backface-visibility: hidden !important;
  -webkit-transform: translateY(3.5em) !important;
  -moz-transform: translateY(3.5em) !important;
  -ms-transform: translateY(3.5em) !important;
  -o-transform: translateY(3.5em) !important;
  transform: translateY(3.5em) !important;
  -webkit-transition: -webkit-transform 1s ease 0s !important;
  -moz-transition: -moz-transform 1s ease 0s !important;
  -ms-transition: -ms-transform 1s ease 0s !important;
  -o-transition: -o-transform 1s ease 0s !important;
  transition: transform 1s ease 0s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-progress-control {
  height: .25em !important;
  top: -.25em !important;
  pointer-events: none !important;
  -webkit-transition: height 1s, top 1s !important;
  -moz-transition: height 1s, top 1s !important;
  -ms-transition: height 1s, top 1s !important;
  -o-transition: height 1s, top 1s !important;
  transition: height 1s, top 1s !important
}

.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-active.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-paused.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-active.vjs-fullscreen .vjs-progress-control,
.video-js.not-hover.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,
.video-js.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control {
  opacity: 0 !important;
  -webkit-transition: opacity 1s ease 1s !important;
  -moz-transition: opacity 1s ease 1s !important;
  -ms-transition: opacity 1s ease 1s !important;
  -o-transition: opacity 1s ease 1s !important;
  transition: opacity 1s ease 1s !important
}

.video-js.vjs-live .vjs-live-control {
  margin-left: 1em !important
}


.vjs-menu-button-popup .vjs-menu {
  bottom: 10px;
}

.video-js .vjs-volume-bar {
  /* margin: 0.7em 0.45em; */
  margin: 1.35em 0.45em;
}

.video-js .vjs-loading-spinner {
  /* border-color: rgba(36, 131, 213, .8) !important */
}

.video-js .vjs-control-bar {
  background-color: transparent !important;
  color: #fff !important;
  font-size: 12px !important;
  text-shadow: 1px 1px 2px black;
  background: linear-gradient(to bottom, rgb(255 255 255 / 0%), rgb(0 0 0 / 52%));
}

.video-js .vjs-play-progress {
  /* background-color: #0199ff !important */
  background-color: #fff !important
}

.video-js .vjs-volume-level {
  background-color: #fff !important
}

.vjs-menu-title {
  display: none !important;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder {
  color: red !important;
}

.video-js .vjs-big-play-button {
  font-size: 5em !important;
  border: none !important;
  background-color: rgba(0, 0, 0, 0.7) !important;
  line-height: 1.2em !important;
  height: 1.2em !important;
  width: 1.2em !important;
  border-radius: 50% !important;
  margin-left: -.6em;
  margin-top: -.6em;
}

.vjs-big-play-centered .vjs-big-play-button {
  margin-left: -0.5em !important;
}

.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 56.25% !important;
}

.vjs-icon-cog:before {
  /* content: ""; */
  /* background-image: url('/cog.svg'); */
  background-size: cover; /* ปรับขนาด SVG ตามต้องการ */
  width: 100%; /* กำหนดความกว้างของ element */
  height: 100%; /* กำหนดความสูงของ element */
}

.vjs-live-display {
  display: none !important;
}

.vjs-menu li {
  line-height: 1.4em !important;
  font-size: 1.2em !important;
}

.vjs-icon-hd:before {
    content: "\F110";
    line-height: 36px !important;
}

.vjs-error .vjs-error-display:before{
  content: "" !important;
}

</style>
